<template>
  <v-container  class="px-0">    
    <v-row wrap class="d-flex flex-row">
      <v-col cols="12" class="py-0 pb-6" >
        <label>Busca</label>
        <v-text-field
          v-model="formData.filter"
          prepend-inner-icon="mdi-magnify"
          placeholder="Em assunto ou mensagem"
          single-line
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="12" class="py-0">
        <label>Módulo</label>
        <v-select
          v-model="formData.modulo"
          :items="modulosFilter"
          item-value="value"
          item-text="label"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
        ></v-select>
      </v-col>
      <v-col cols="12" class="py-0">
        <label>Prestador</label>
        <v-select
          v-model="formData.prestador_id"
          :items="prestadoresFilter"
          item-value="id"
          item-text="prest_nome"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
        ></v-select>
      </v-col>

      <v-col cols="12" class="py-0" >
        <v-badge light inline color="accent" class="black--text mt-0" :content="importantMessagesCount"
          :value="importantMessagesCount">
        <v-checkbox class="mt-0 py-0" v-model="formData.prioridade_alta" label="Alta importância" @change="filterList(formData)"></v-checkbox>
        </v-badge>
      </v-col>
      
      <v-col cols="6" class="py-0">
        <v-btn outlined small height="30px" color="primary" @click="clearFilter()">Limpar Filtro</v-btn>
      </v-col>
      <v-col cols="6" class="text-right py-0">
        <v-btn depressed small height="30px" color="primary" @click="filterList(formData)">Filtrar</v-btn>
      </v-col>

      
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      formData:{
        prioridade_alta: false,
        modulo: null,
        filter: null,
        prestador_id: null,
      },
      modulosFilter:[],
      prestadoresFilter:[]
    };
  },
  // mounted(){
  //   let val = Object.keys(this.permission)
  //   let allowedModule = this.modules.filter(el => el.value == val.find(val => val == el.value))
  //   this.modulosFilter = Array.from(allowedModule)
  //   this.modulosFilter.unshift({value: null, label: "Selecione"})
  // },
  watch: {
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = this.prestadoresFilter[0].id
        }  else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        }
      }
    },
    modules:{
      deep: true,
      handler(){
        let val = Object.keys(this.permission)
        let allowedModule = this.modules.filter(el => el.value == val.find(val => val == el.value))
        this.modulosFilter = Array.from(allowedModule)
        this.modulosFilter.unshift({value: null, label: "Selecione"})
      }
    }
  },
  methods: {
    clearFilter() {
      this.formData.prioridade_alta = false
      this.formData.filter = null
      this.formData.modulo = null
      this.formData.prestador_id = this.prestadoresFilter.length==1? this.formData.prestador_id : null
      this.filterList(this.formData)
    }
  },
  props: {
    filterList: Function,
    getList: Function,
    importantMessagesCount: Number,
    modules: Array,
    prestadores: Array,
    permission: Object
  }
};
</script>

<style>
</style>